import { contacts } from '@/settings'
import popupPolicyHtml from './popupPolicyHtml'
import homePage from './homePage'
import projects from './projects'
import reviews from './reviews'
import privacyContent from '!!raw-loader!@/service/content/ru/privacy.html'

export default {
	// Импорт:
	popupPolicyHtml,
	homePage,
	projects,
	reviews,

	// Общие фразы:
	viewProjects: 'Смотреть проекты',
	discussIdea: 'Обсудить идею',
	discussProject: 'Обсудить проект',
	sendRequest: 'Отправить заявку',
	leaveRequest: 'Оставить заявку',
	back: 'Назад',
	excellent: 'Отлично',
	userAgreement: 'Пользовательское соглашение',
	privacyPolicy: 'Политика конфиденциальности',
	TextITN: 'ИНН',
	TextPSRN: 'ОГРНИП',
	selected: 'Выбрано',
	apply: 'Применить',
	clear: 'Очистить',
	categories: 'Категории',
	allСategories: 'Все категории',
	selectCategories: 'Выбрать категории',
	and: 'и',
	thanks: 'Спасибо',
	see: 'Смотреть',
	expand: 'Развернуть',
	narrow: 'Свернуть',

	// Инфа о компании, контакты и пр:
	company: {
		name: 'Глобал Код',
		slogan: 'Объединяем компании и людей',
		officialName: 'ИП Филимонов А.А.',
		ITN: contacts.ITN,
		PSRN: contacts.PSRN,
		email: contacts.email,
		whatsapp: contacts.whatsapp,
		phone: contacts.phone,
		vk: contacts.vk,
		facebook: contacts.facebook,
		instagram: contacts.instagram,
		youtube: contacts.youtube,
		telegram: contacts.telegram,
	},

	// Меню:
	menu: {
		homePage: 'Главная',
		menu: 'Меню',
		projects: 'Проекты',
		team: 'Команда',
		services: 'Услуги',
		reviews: 'Отзывы',
		contacts: 'Контактная информация',
		contactsShort: 'Контакты',
		call: 'Звонок',
	},

	// Форма:
	form: {
		enterPhone: 'Введите ваш номер телефона',
		enterName: 'Введите Ваше имя',
		attachFile: 'Прикрепить файл',
		attachFileText: 'ТЗ на проект (если есть)',
		attachFileTextMobile:
			'Если у вас нет технических данных для расчёта, но есть смета или спецификация, прикрепите документ',
		enterComment: 'Оставьте комментарий',
		recaptchaText: 'Данный сайт защищен reCAPTCHA от Google.',
		occurredErrors: 'При отправке формы возникли ошибки',
		successfullySent: 'Ваша заявка успешно отправлена',
		send: 'Отправить заявку',
		sending: 'Отправка...',
		choosedFiles: 'Выбрано {amount} файла(ов)',
		phoneFormatError: 'Номер телефона имеет ошибочный формат',
		maxFilesError:
			'Вы загрузили слишком много файлов. Макс. число файлов для загрузки - {maxFiles}',
		privacyAgreement: {
			text: 'Я согласен',
			link: 'с политикой конфиденциальности',
			error: 'Дайте согласие',
		},
	},

	cookiesTooltip: {
		text: 'Мы используем cookie для быстрой и удобной работы сайта. Продолжая пользоваться сайтом, вы даете согласие на использование файлов cookie.',
		link: 'Подробнее.',
		btn: 'Принять',
	},

	// Страницы проектов:
	projectsPage: {
		title: 'Проекты',
		site: 'Сайт',
		iosApp: 'Приложение для IOS',
		androidApp: 'Приложение для Android',
	},

	// Страницы и карточки отзывов:
	reviewsPage: {
		title: 'Отзывы',
		allReviews: 'Все отзывы',
		contactCustomer: 'Связаться с клиентом',
		projectCase: 'Кейс проекта',
		completedProjects: 'Реализованные проекты',
		apps: 'Приложения',
		site: 'Сайт',
		socials: 'Соцсети',
		task: 'Задача',
		coopDuration: 'Длительность сотрудничества',
	},

	privacyPage: {
		title: 'Политика в отношении обработки персональных данных',
		content: privacyContent,
	},
}
